// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactFinalForm from "react-final-form";
import * as JotaiAtoms$OrcaPaymentPage from "../../Utilities/JotaiAtoms.bs.js";
import * as DropdownField$OrcaPaymentPage from "../DropdownField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../../Utilities/DynamicFieldsUtils.bs.js";

function BankNamesSelectField(props) {
  var options = props.options;
  var fieldConfig = props.fieldConfig;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = DynamicFieldsUtils$OrcaPaymentPage.resolveFieldTexts(fieldConfig, localeString);
  var validate = DynamicFieldsUtils$OrcaPaymentPage.resolveValidator(fieldConfig, localeString);
  var initialValue = Core__Option.getOr(Core__Option.map(options[0], (function (opt) {
              return opt.value;
            })), "");
  var field = ReactFinalForm.useField(fieldConfig.confirmRequestWritePath, {
        initialValue: Caml_option.some(initialValue),
        validate: validate
      });
  var value = Core__Option.getOr(field.input.value, initialValue);
  return React.createElement(DropdownField$OrcaPaymentPage.make, {
              appearance: match.config.appearance,
              value: value,
              setValue: (function (fn) {
                  field.input.onChange(fn(value));
                }),
              fieldName: match$1.label,
              options: options,
              disabled: false
            });
}

var make = BankNamesSelectField;

export {
  make ,
}
/* jotai Not a pure module */
